module.exports = __webpack_public_path__ + "static/img/tree.e349526.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tree.jpg
// module id = 5Wnb
// module chunks = 1